var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Dialog, Icon, Table } from "@material-ui/core";
import { WebSocketMessage } from "../../serverConnection";
function TabContainer(props) {
    return (React.createElement(Typography, { component: "div", style: { padding: 8 * 3 } }, props.children));
}
var ProductTable = /** @class */ (function (_super) {
    __extends(ProductTable, _super);
    function ProductTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { value: 0, open: -1 };
        _this.handleChange = function (_, value) {
            _this.setState({ value: value });
        };
        return _this;
    }
    ProductTable.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        var products = function (country) {
            return _this.props.products
                .filter(function (product, index) {
                return product.country === country;
            })
                .map(function (product, i) { return (React.createElement("tr", { key: product.id },
                React.createElement("td", null, product.name),
                React.createElement("td", null,
                    product.price.amount,
                    " ",
                    product.price.currency),
                React.createElement("td", null,
                    product.fee.amount,
                    " ",
                    product.fee.currency),
                React.createElement("td", null,
                    product.premium.amount,
                    " ",
                    product.premium.currency),
                React.createElement("td", null,
                    product.vat,
                    " %"),
                React.createElement("td", null, product.locations),
                React.createElement("td", null,
                    React.createElement(Link, { to: "/products/" + product.id, className: "btn btn-flat" },
                        React.createElement(Icon, null, "edit"))),
                React.createElement("td", null,
                    React.createElement(Button, { onClick: function () { return _this.setState({ open: i }); } },
                        React.createElement(Icon, null, "clear")),
                    React.createElement(Dialog, { open: _this.state.open === i, onClose: function () { return _this.setState({ open: -1 }); } },
                        React.createElement("div", { style: { margin: 8 } },
                            React.createElement("p", null,
                                "Are you sure you want to delete ",
                                product.name,
                                "?"),
                            React.createElement("br", null),
                            " ",
                            React.createElement("br", null),
                            React.createElement(Button, { className: "red darken-2", onClick: function () { return _this.onProductDeleteClick(product.id); } },
                                React.createElement(Icon, null, "delete"),
                                " Delete"),
                            " ",
                            "\u00A0",
                            React.createElement(Button, { onClick: function () { return _this.setState({ open: -1 }); } }, "Close")))))); });
        };
        return (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col s12 m12 l12" },
                React.createElement("h5", null, "Products"),
                React.createElement("br", null),
                React.createElement(Tabs, { value: value, onChange: this.handleChange, className: "white z-depth-1" },
                    React.createElement(Tab, { label: "Germany" }),
                    React.createElement(Tab, { label: "Bahamas" }),
                    React.createElement(Tab, { label: "South Africa" })),
                React.createElement("br", null),
                value === 0 && (React.createElement("div", { className: "white z-depth-1" },
                    React.createElement(TabContainer, null,
                        React.createElement(Table, null,
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, "Product"),
                                    React.createElement("th", null, "Price"),
                                    React.createElement("th", null, "Setup"),
                                    React.createElement("th", null, "Premium"),
                                    React.createElement("th", null, "VAT"),
                                    React.createElement("th", null, "Locations"),
                                    React.createElement("th", null),
                                    React.createElement("th", null))),
                            React.createElement("tbody", null, products("DE")))))),
                value === 1 && (React.createElement("div", { className: "white z-depth-1" },
                    React.createElement(TabContainer, null,
                        React.createElement(Table, null,
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, "Product"),
                                    React.createElement("th", null, "Price"),
                                    React.createElement("th", null, "Setup"),
                                    React.createElement("th", null, "Premium"),
                                    React.createElement("th", null, "VAT"),
                                    React.createElement("th", null, "Locations"),
                                    React.createElement("th", null),
                                    React.createElement("th", null))),
                            React.createElement("tbody", null, products("BS")))))),
                value === 2 && (React.createElement("div", { className: "white z-depth-1" },
                    React.createElement(TabContainer, null,
                        React.createElement(Table, null,
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, "Product"),
                                    React.createElement("th", null, "Price"),
                                    React.createElement("th", null, "Setup"),
                                    React.createElement("th", null, "Premium"),
                                    React.createElement("th", null, "VAT"),
                                    React.createElement("th", null, "Locations"),
                                    React.createElement("th", null))),
                            React.createElement("tbody", null, products("ZA")))))))));
    };
    ProductTable.prototype.onProductDeleteClick = function (id) {
        this.setState({ open: -1 });
        this.props.send(WebSocketMessage("products", "delete", { id: id }));
    };
    return ProductTable;
}(Component));
export default ProductTable;



//////////////////
// WEBPACK FOOTER
// ./src/components/products/ProductTable.tsx
// module id = 1279
// module chunks = 0